// extracted by mini-css-extract-plugin
module.exports = {"anchorMenuContainer":"anchorMenu-module__anchorMenuContainer___1nf81"};